import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CryptoJS from 'crypto-js';
import { useSelector, useDispatch } from 'react-redux';
import TermsAndConditionDialog from 'components/TermsAndCondition';
import { getCountries } from 'actions/countries';
import { updateField } from 'actions/common';
import AccountInformationDialog from 'pages/home/Header/AccountInformationDialog';
import {
  SET_USER_EMAIL,
  SET_USER_PASSWORD,
  USER_INITIATE,
  UPDATE_USER_FIELD,
  SET_USER_CONFIRM_PASSWORD,
  TOGGLE_TERMS_AND_CONDITION,
} from 'actions/user';
import { signUp } from 'actions/auth';
import Dialog from '@material-ui/core/Dialog';
import Button from 'components/Button';
import TextField from 'components/TextField';
import Select from 'components/Select';
import COLORS from 'shared/constants/colors';
import CustomCheckbox from 'components/CheckBox';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import {
  Container,
  Header,
  Body,
  Footer,
  Column,
  Fields,
  Description,
  Terms,
  FieldsGroup,
} from 'styles/pages/home/signUpDialog';

const SignUpDialog = ({ open, onClose, showLoginModal }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);
  const countries = useSelector((state) => state?.countries?.data);
  const [accountInFoDialogVisibility, setAccountInfoDialog] = useState(false);

  useEffect(() => {
    const loadCountries = async () => {
      if (!countries?.length) {
        dispatch(getCountries());
      }
    };
    loadCountries();
  }, [dispatch, countries]);

  const name = user?.name;
  const email = user?.email;
  const company = user?.company;
  const address1 = user?.address1;
  const address2 = user?.address2;
  const city = user?.city;
  const zip = user?.zip;
  const country = user?.country;
  const state = user?.state;
  const password = user?.password;
  const companyUrl = user?.companyUrl;
  const companyInfo = user?.companyInfo;
  const companyNumber = user?.companyNumber;
  const confirmPassword = user?.confirmPassword;
  const homeBased = user?.homeBased;
  const physicalStore = user?.physicalStore;
  const decoratingEquipment = user?.decoratingEquipment;
  const hearAbout = user?.hearAbout;
  const businessType = user?.businessType;
  const agreeTermsAndCondition = user?.agreeTermsAndCondition;

  const [statesList, setStateList] = useState(undefined);
  const [termsDialog, setTermsDialog] = useState(false);

  const disabled =
    !name?.valid ||
    !email?.valid ||
    !company?.valid ||
    !address1?.valid ||
    !country?.valid ||
    !state?.valid ||
    !city?.valid ||
    !zip?.valid ||
    !password?.valid ||
    !companyUrl?.valid ||
    !companyInfo?.valid ||
    !confirmPassword?.value ||
    !homeBased?.value ||
    !physicalStore?.value ||
    !decoratingEquipment?.value ||
    !businessType?.value ||
    !hearAbout?.value ||
    password?.value !== confirmPassword?.value ||
    !agreeTermsAndCondition;

  return (
    <Dialog
      open={open}
      maxWidth='xl'
      onClose={() => {
        dispatch(updateField(USER_INITIATE));
        _.isFunction(onClose) && onClose();
      }}>
      <Container>
        <Column>
          <Fields>
            <Header>
              <img src='https://bigoventees.com/img/back2.png' alt='logo' />
              <h4> Sign Up to Big Oven Tees</h4>
            </Header>
            <Body>
              <FieldsGroup>
                <TextField
                  fullWidth
                  size='small'
                  label='Name'
                  error={!!(name?.value && !name?.valid)}
                  helperText={name?.value && !name?.valid ? 'Enter name' : null}
                  value={name?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'name' })
                    )
                  }
                />
                <TextField
                  fullWidth
                  size='small'
                  label='Email'
                  error={!!(email?.value && !email?.valid)}
                  helperText={
                    email?.value && !email?.valid ? 'Enter valid email' : null
                  }
                  value={email?.value || ''}
                  onChange={(v) =>
                    dispatch(updateField(SET_USER_EMAIL, { email: v }))
                  }
                />
              </FieldsGroup>

              <FieldsGroup>
                <TextField
                  fullWidth
                  type='password'
                  size='small'
                  label='Password'
                  error={!!(password?.value && !password?.valid)}
                  helperText={
                    password?.value && !password?.valid
                      ? `Password should be of minimum ${password.MINIMUM_PASSWORD_LENGTH} characters `
                      : null
                  }
                  value={password?.value || ''}
                  onChange={(v) =>
                    dispatch(updateField(SET_USER_PASSWORD, { password: v }))
                  }
                />
                <TextField
                  fullWidth
                  size='small'
                  type='password'
                  label='Confirm Password'
                  error={!!(confirmPassword?.value && !confirmPassword?.valid)}
                  helperText={
                    confirmPassword?.value && !confirmPassword?.valid
                      ? `Password should be of minimum ${password.MINIMUM_PASSWORD_LENGTH} characters `
                      : null
                  }
                  value={confirmPassword?.value || ''}
                  onChange={(v) =>
                    dispatch(
                      updateField(SET_USER_CONFIRM_PASSWORD, {
                        confirmPassword: v,
                      })
                    )
                  }
                />
              </FieldsGroup>

              <h3
                style={{
                  borderBottom: '1px solid #ccc',
                  paddingBottom: 10,
                  marginBottom: 20,
                  marginTop: 0,
                }}>
                Company Details
              </h3>
              <FieldsGroup>
                <TextField
                  fullWidth
                  size='small'
                  label='Company Name'
                  error={!!(company?.value && !company?.valid)}
                  helperText={
                    company?.value && !company?.valid ? 'Enter company' : null
                  }
                  value={company?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'company' })
                    )
                  }
                />
                <TextField
                  fullWidth
                  size='small'
                  label='Company Website URL'
                  error={!!(companyUrl?.value && !companyUrl?.valid)}
                  helperText={
                    companyUrl?.value && !companyUrl?.valid
                      ? 'Enter company Website Url'
                      : null
                  }
                  value={companyUrl?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'companyUrl',
                      })
                    )
                  }
                />
              </FieldsGroup>

              <FieldsGroup>
                <TextField
                  fullWidth
                  size='small'
                  label='Address1'
                  error={!!(address1?.value && !address1?.valid)}
                  helperText={
                    address1?.value && !address1?.valid
                      ? 'Enter address1'
                      : null
                  }
                  value={address1?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'address1' })
                    )
                  }
                />
                <TextField
                  fullWidth
                  size='small'
                  label='Address2'
                  error={!!(address2?.value && !address2?.valid)}
                  helperText={
                    address2?.value && !address2?.valid
                      ? 'Enter address2'
                      : null
                  }
                  value={address2?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'address2' })
                    )
                  }
                />
              </FieldsGroup>

              <FieldsGroup>
                <Select
                  label='Country'
                  options={countries}
                  labelKey='name'
                  valueKey='code2'
                  value={{ code2: country?.value || '' }}
                  onChange={(CountryString) => {
                    const states = _.find(
                      countries,
                      (o) => o.code2 === CountryString
                    )?.states;
                    setStateList(states);

                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value: CountryString,
                        key: 'country',
                      })
                    );

                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value: null,
                        key: 'state',
                      })
                    );
                  }}
                />
                <Select
                  label='State/Province'
                  labelKey='name'
                  valueKey='code'
                  options={statesList}
                  value={{ code: state?.value || '' }}
                  onChange={(StateProvince) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value: StateProvince,
                        key: 'state',
                      })
                    )
                  }
                />
              </FieldsGroup>
              <FieldsGroup>
                <TextField
                  fullWidth
                  size='small'
                  label='City'
                  error={!!(city?.value && !city?.valid)}
                  helperText={city?.value && !city?.valid ? 'Enter city' : null}
                  value={city?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'city' })
                    )
                  }
                />
                <TextField
                  fullWidth
                  size='small'
                  label='Zip'
                  error={!!(zip?.value && !zip?.valid)}
                  helperText={zip?.value && !zip?.valid ? 'Enter zip' : null}
                  value={zip?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, { value, key: 'zip' })
                    )
                  }
                />
              </FieldsGroup>

              <FieldsGroup>
                <TextField
                  fullWidth
                  size='small'
                  label='Business Type'
                  error={!!(businessType?.value && !businessType?.valid)}
                  helperText={
                    businessType?.value && !businessType?.valid
                      ? 'Required Field'
                      : null
                  }
                  value={businessType?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'businessType',
                      })
                    )
                  }
                />

                <TextField
                  fullWidth
                  size='small'
                  label='Resell Number / Trade ID / PST#'
                  error={!!(companyNumber?.value && !companyNumber?.valid)}
                  helperText={
                    companyNumber?.value && !companyNumber?.valid
                      ? 'Required Field'
                      : null
                  }
                  value={companyNumber?.value || ''}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'companyNumber',
                      })
                    )
                  }
                />
              </FieldsGroup>

              <TextareaAutosize
                id='tell-us'
                style={{ height: 100 }}
                value={companyInfo?.value}
                placeholder='Tell us about your work or your business*'
                value={companyInfo?.value || ''}
                onChange={(e) =>
                  dispatch(
                    updateField(UPDATE_USER_FIELD, {
                      value: e.target.value,
                      key: 'companyInfo',
                    })
                  )
                }
              />

              <FieldsGroup style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <Select
                  label='Do you have a home-based business?'
                  options={['Yes', 'No']}
                  value={homeBased?.value}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'homeBased',
                      })
                    )
                  }
                />
                <Select
                  label='Do you have a physical retail store?'
                  options={['Yes', 'No']}
                  value={physicalStore?.value}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'physicalStore',
                      })
                    )
                  }
                />

                <Select
                  label='Do you have your own decorating equipment?'
                  options={['Yes', 'No']}
                  value={decoratingEquipment?.value}
                  onChange={(value) =>
                    dispatch(
                      updateField(UPDATE_USER_FIELD, {
                        value,
                        key: 'decoratingEquipment',
                      })
                    )
                  }
                />
              </FieldsGroup>

              <Select
                label='How did you hear about us?'
                options={[
                  'Online Search',
                  'Social Media',
                  'Print Ad',
                  'Trade Show',
                  'Referral',
                ]}
                value={hearAbout?.value}
                onChange={(value) =>
                  dispatch(
                    updateField(UPDATE_USER_FIELD, {
                      value,
                      key: 'hearAbout',
                    })
                  )
                }
              />

              <Terms>
                <CustomCheckbox
                  label=''
                  checked={agreeTermsAndCondition}
                  onChange={() =>
                    dispatch(updateField(TOGGLE_TERMS_AND_CONDITION))
                  }
                />
                <p>
                  Agree to Big Oven Tees&nbsp;
                  <span onClick={() => setTermsDialog(true)}>
                    Terms and Conditions
                  </span>
                </p>
              </Terms>

              <Button
                disabled={disabled}
                variant='contained'
                title='Sign Up'
                onClick={async () => {
                  const request = await dispatch(
                    await signUp({
                      name: name?.value,
                      email: email?.value,
                      company: company?.value,
                      address1: address1?.value,
                      address2: address2?.value,
                      businessType: businessType?.value,
                      city: city?.value,
                      state: state?.value,
                      country: country?.value,
                      zip: zip?.value,
                      companyUrl: companyUrl?.value,
                      companyInfo: companyInfo?.value,
                      companyNumber: companyNumber?.value,
                      homeBased: homeBased?.value,
                      physicalStore: physicalStore?.value,
                      decoratingEquipment: decoratingEquipment?.value,
                      hearAbout: hearAbout?.value,
                      password: CryptoJS.AES.encrypt(
                        password?.value,
                        'bot'
                      ).toString(),
                    })
                  );

                  if (request?.error) {
                    return;
                  }

                  setAccountInfoDialog(true);
                }}
              />
            </Body>
            <Footer>
              <Button
                containerStyle={{
                  backgroundColor: COLORS.WHITE,
                  textTransform: 'unset',
                  lineHeight: '1.5',
                  color: COLORS.GREY,
                }}
                variant='text'
                title='Sign In'
                onClick={() => _.isFunction(showLoginModal) && showLoginModal()}
              />
            </Footer>
          </Fields>
          <Description>
            <h4>Connect your ecommerce store and save on fulfillment</h4>
            <p>Simple, intuitive integrations with Shopify, WooCommerce</p>
            <h4>Easily. Efficiently. Big Oven Tees</h4>
            <p>
              We print, package and ship your orders straight to your customers
              - duty-free, across all of North America
            </p>
            <h4>Your apparel ally</h4>
            <p>
              We help you shift your business from simply stitched together to
              bursting at the seams, one shirt at a time
            </p>
          </Description>
        </Column>
      </Container>
      {termsDialog && (
        <TermsAndConditionDialog
          open={termsDialog}
          setOpen={(v) => setTermsDialog(v)}
        />
      )}

      {accountInFoDialogVisibility && (
        <AccountInformationDialog
          open={accountInFoDialogVisibility}
          inProcess={true}
          onClose={() => {
            setAccountInfoDialog(false);
            _.isFunction(onClose) && onClose();
          }}
        />
      )}
    </Dialog>
  );
};

SignUpDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SignUpDialog;
